// extracted by mini-css-extract-plugin
export default {"spinerCat":"Loader_spinerCat__cFhL6"};